export default __webpack_public_path__ + "static/media/Grzywa.59e63129.png";